import React from 'react'
import keyboardJS from 'keyboardjs';

class Keyboard extends React.Component{
  componentDidMount(){
    keyboardJS.bind(this.props.keypress, this.props.onPress)
  }
  componentWillUnmount(){
    keyboardJS.unbind(this.props.keypress)
  }
  render(){
    return (this.props.children);
  }
}

export default Keyboard;



// WEBPACK FOOTER //
// ./src/components/shared/keyboard/index.js